import React from "react";
import "./PageNotFound.css";
import { useTranslation } from "react-i18next";

const PageNotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="pagenotfound">
      <h1>{t("page_not_found")}</h1>
      <p onClick={() => window.history.back()}>{t("go_back")}</p>
    </div>
  );
};

export default PageNotFound;
